import React, { ReactElement, useEffect, useLayoutEffect, useState, useMemo, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getDateArr } from '../../../../components/data-selection/formDate';
import './index.less';
import FullLoading from '../../../../components/full-loading';
import {
  formateDatePile,
  webviewOpen,
  goBackCompatible
} from '../../../../utils/common';
import {
  confirmInstallation,
  getInstallProgress,
  scheduledSurvey,
  getCoupons
} from '../../../../api/filling-pile';
import completed from '@assets/completed.png';
import bigCircular from '@assets/big-circular.png';
import smallCircular from '@assets/small-circular.png';
import redCirdular from '@assets/red-circular.png';
import arrow from '@assets/arrow.png';
import yellowStar from '@assets/yellow-star.png';
import star from '@assets/star.png';
import emptyStatus from '@assets/emptyStatus.png';
import DatePicker from '../../../../components/data-selection/index';
import { getClientEnv, getLoginInfoPromise } from '../../../../utils/common';
import { navHide } from '../../../../utils/common'
import { querySharePileInfo } from '../../../../api/pile-sharing';
import SharePileModal, { getTypeData } from '../../components/share-pile-modal';
import { trackGdp } from '../../../../utils/gio-report';
import { useInViewport } from 'ahooks';
interface Data {
  urgeDate: any;
  urged: boolean;
}

const questionInfoList = [
  { name: '电力报装/物业协商', value: 'negotiationTrouble' },
  { name: '考虑其他品牌', value: 'considerOtherBrands' },
  { name: '功能不完善', value: 'functionalImperfection' },
  { name: '无固定车位', value: 'noFixedParkingSpace' },
  { name: '增项费用高', value: 'theCostOfAdditionalItemsIsHigh' },
  { name: '退款重拍', value: 'refundReshoot' },
  { name: '其他', value: 'other' },
  { name: '预约安装不及时', value: 'untimelyHandling' },
  { name: '不按标准收费', value: 'arbitraryCharge' },
  { name: '客服回复不及时', value: 'customerServiceReplyIsNotTimely' },
  { name: '客服态度差', value: 'poorCustomerServiceAttitude' },
  { name: '安装师傅态度差', value: 'badAttitude' },
]

const Survey = (): ReactElement => {
  const router = useHistory();
  const loc = useLocation();
  const parmas = new URLSearchParams(loc.search);
  const UA = navigator.userAgent || '';
  const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
  const orderNo: any = parmas.get('orderNo') || '';
  const [date, setDate] = useState<any>([]);
  const [isUrge, setIsUrge] = useState<Data>({
    urgeDate: new Date().getDate(),
    urged: false
  });
  const [orderInfo, setOrderInfo] = useState<any>();
  const [surveyInfo, setSurveyInfo] = useState<any>();
  const [installationInfo, setInstallation] = useState<any>();
  const [uid, setUid] = useState('');
  const [show, setShow] = useState<boolean>(false);
  const [questionInfo, setQuestionInfo] = useState<any>();
  const [surveyTime, setSurveyTime] = useState('');
  const [evaluateGrade, setEvaluateGrade] = useState([
    star,
    star,
    star,
    star,
    star
  ]);
  const [emptyShow, setEmptyShow] = useState<boolean>(false);
  const showState = () => {
    setShow(true);
  };
  const [startY, setStartY] = useState(0)
  const [num, setNum] = useState<number>(0)
  const [showCoupons, setShowCoupons] = useState<any>({
    info: '',
    show: false
  });
  const [pileShareInfo, setPileShareInfo] = useState<any>({})
  const [visible, setVisible] = useState<boolean>(false)
  const suery = useRef<any>()
  const [isInView] = useInViewport(suery.current)

  const installationGuide = () => {
    if (window.location.href.indexOf('static.xiaopeng.com') !== -1) {
      webviewOpen('xiaopeng://bbs/article?tid=1053621');
    } else {
      window.location.href =
        'https://bbs.xiaopeng.com/v2/landing/bbsDetail.html?tid=1053621&token=ebb1ab68';
    }
  };
  const gotoEvaluation = () => {
    if (orderInfo.orderStatus === '30') {
      router.push({
        pathname: '/cancel-service',
        search: '?orderNo=' + (orderInfo.orderNo ? orderInfo.orderNo : '')
      });
    } else {
      router.push({
        pathname: '/evaluation-service',
        search: '?orderNo=' + (orderInfo.orderNo ? orderInfo.orderNo : '')
      });
    }
  };
  const gotoInstallReport = () => {
    router.push({
      pathname: '/install-report',
      search:
        '?orderNo=' +
        (orderInfo.orderNo ? orderInfo.orderNo : '') +
        '&uid=' +
        (uid ? uid : '')
    });
  };
  const gotoSurveyReport = () => {
    router.push({
      pathname: '/survey-report',
      search:
        '?orderNo=' +
        (orderInfo.orderNo ? orderInfo.orderNo : '') +
        '&uid=' +
        (uid ? uid : '')
    });
  };
  const surveyFee = () => {
    let sum = 0;
    if (
      surveyInfo.surveySelfFeeProject &&
      surveyInfo.surveySelfFeeProject.length > 0
    ) {
      surveyInfo.surveySelfFeeProject.forEach(item => {
        sum += item.price * item.amount;
      });
      return Math.round(sum * 100) / 100;
    }
    return Math.round(sum * 100) / 100;
  };
  const installFee = () => {
    let sum = 0;
    if (
      installationInfo.installSelfFeeProject &&
      installationInfo.installSelfFeeProject.length > 0
    ) {
      installationInfo.installSelfFeeProject.forEach(item => {
        sum += item.price * item.amount;
      });
      return Math.round(sum * 100) / 100;
    }
    return Math.round(sum * 100) / 100;
  };
  const installationConfig = () => {
    FullLoading.show({
      text: '确认中'
    });
    confirmInstallation({ uid, orderNo: orderInfo.orderNo })
      .then(() => {
        FullLoading.hide();
        getInstallProgress({ uid, orderNo: orderInfo.orderNo }).then(
          resInfo => {
            setOrderInfo(resInfo.data);
            console.log(resInfo.data);
          }
        );
      })
      .catch(err => {
        console.error(err);
      }).finally(() => {
        FullLoading.hide();
      });
  };

  const urge = () => {
    router.push({
      pathname: '/urging',
      search: '?orderNo=' + (orderInfo.orderNo ? orderInfo.orderNo : ''),
      orderType: 'install'
    });
    setIsUrge({
      urged: true,
      urgeDate: new Date().getDate()
    });
  };

  const showEvaluateBtn = orderInfo => {
    let orderStatus =
      orderInfo.orderStatus === '21' ||
      orderInfo.orderStatus === '24' ||
      orderInfo.orderStatus === '30' ||
      orderInfo.orderStatus === '33';

    let evaluateBtnFlag =
      (orderInfo && orderInfo.finishQuestionnaire === 0 && orderStatus) ||
      false;
    return evaluateBtnFlag;
  };
  //预约勘测时间/更改勘测时间
  const onSure = selectedIndexs => {
    FullLoading.show({
      text: '加载中'
    });
    if (!selectedIndexs[0] && !selectedIndexs[1]) {
      const selectTime = `${date[0][0].text}${date[1][0].text}`;

      scheduledSurvey({
        uid,
        orderNo: orderInfo.orderNo,
        scheduleSurveyTime: date[0][0].value,
        scheduleSurveyTimeSlot: date[1][0].text
      });
      getInstallProgress({ uid, orderNo: orderInfo.orderNo }).then(res => {
        setOrderInfo(res.data);
        FullLoading.hide();
        console.log(res.data);
      });
      setSurveyTime(selectTime);
      setShow(false);
      return;
    }
    if (selectedIndexs[0] === 0 && selectedIndexs[1] !== 0) {
      const time = selectedIndexs[1];
      scheduledSurvey({
        uid,
        orderNo: orderInfo.orderNo,
        scheduleSurveyTime: date[0][0].value,
        scheduleSurveyTimeSlot: date[1][time].text
      });
      getInstallProgress({ uid, orderNo: orderInfo.orderNo }).then(res => {
        FullLoading.hide();
        setOrderInfo(res.data);
        console.log(res.data);
      });
      setShow(false);
      return;
    }
    const month = selectedIndexs[0];
    const time = selectedIndexs[1];
    const selectTime = `${date[0][month].text}${date[1][time].text}`;
    scheduledSurvey({
      uid,
      orderNo: orderInfo.orderNo,
      scheduleSurveyTime: date[0][month].value,
      scheduleSurveyTimeSlot: date[1][time].text
    });
    getInstallProgress({ uid, orderNo: orderInfo.orderNo }).then(res => {
      FullLoading.hide();
      setOrderInfo(res.data);
      console.log(res.data);
    });
    setSurveyTime(selectTime);
    setShow(false);
    return;
  };
  const shwoConfirmWithManagement = () => {
    if (
      orderInfo.confirmWithManagement === 0 &&
      orderInfo.orderStatus !== '30' &&
      orderInfo.orderStatus !== '09' &&
      orderInfo.orderStatus !== '12' &&
      orderInfo.orderStatus !== '15' &&
      orderInfo.orderStatus !== '18' &&
      orderInfo.orderStatus !== '18' &&
      orderInfo.orderStatus !== '21' &&
      orderInfo.orderStatus !== '24' &&
      orderInfo.orderStatus !== '33'
    ) {
      return (
        <div className="property">
          <img src={bigCircular} alt="" className="bigCircular" />
          <div className="survey-time">
            <div className="title">请跟物业沟通是否能安装</div>
            <div className="btn">
              <div onClick={installationGuide}>
                电力报装指南
                <img src={arrow} alt="" />
              </div>
              <button onClick={installationConfig}>已确认，下一步</button>
            </div>
          </div>
        </div>
      );
    }
    return '';
  };
  const communicationGuide = () => {
    if (
      orderInfo.confirmWithManagement === 1 ||
      orderInfo.orderStatus === '09' ||
      orderInfo.orderStatus === '12' ||
      orderInfo.orderStatus === '15' ||
      orderInfo.orderStatus === '18' ||
      orderInfo.orderStatus === '21' ||
      orderInfo.orderStatus === '24' ||
      orderInfo.orderStatus === '33'
    ) {
      return (
        <div
          className="property-confirm"
          style={{ display: orderInfo.orderStatus === '30' ? 'none' : 'flex' }}
        >
          <img src={smallCircular} alt="" className="smallCircular" />
          <p>物业沟通指南</p>
          <button onClick={installationGuide}>报装指南</button>
        </div>
      );
    }
    return '';
  };

  const couponsClass = useMemo(() => {
    return num > 0 ? 'coupons coupons-anmiation-immediately' : 'coupons coupons-anmiation'
  }, [num])

  useEffect(() => {
    if (localStorage.getItem('coupons')) {
      couponsInfo()
    }

  }, [orderNo])

  const couponsInfo = () => {
    getCoupons(orderNo).then(({ data, code }) => {
      if ([0, 200].includes(code)) {
        if (data && data.prizeDesc) {
          showCoupons.show = true
          showCoupons.info = data.prizeDesc
          localStorage.removeItem('coupons')
          setShowCoupons(showCoupons)
        }
      }
    })
  }

  const onTouchStart = (e) => {
    e.persist()
    setStartY(e.touches[0].clientY)
  }

  const getY = (clientY) => {
    if (clientY - startY < 0) {
      setNum(val => val += 1)
    }
    if (num === 2) {
      console.log('往上滑');
    }
  }

  const onTouchMove = (e) => {
    e.persist()
    getY(e.touches[0].clientY)
  }

  const goBack = () => {
    goBackCompatible()
  }

  useLayoutEffect(() => {
    // 隐藏导航栏
    navHide();
  }, []);

  useEffect(() => {
    const handleNavHide = () => {
      navHide();
      setTimeout(() => {
        navHide();
      }, 100);
    }; // 100 毫秒内最多执行一次

    document.addEventListener('visibilitychange', handleNavHide);

    // 清理事件监听器
    return () => {
      document.removeEventListener('visibilitychange', handleNavHide);
    };
  }, []);

  useEffect(() => {
    trackGdp('P20224', 'B001', {
      orderNo: orderNo
    })
    // setTitle();
    //获取往后六十天的日期
    let arr = getDateArr(60);
    setDate([
      arr,
      [
        { text: '上午(9:00-12:00)', value: '上午' },
        { text: '下午(1:00-6:00)', value: '下午' }
      ]
    ]);
    FullLoading.show({
      text: '加载中'
    });
    getLoginInfoPromise()
      .then(res => {
        const uid = `${res.uid}`;
        setUid(uid);
        getInstallProgress({ uid, orderNo: orderNo })
          .then(res => {
            if (JSON.stringify(res.data) == '{}' || null) {
              FullLoading.hide();
              setEmptyShow(true);
              return;
            }
            setOrderInfo(res.data);
            console.log(res.data);

            if (res.data.surveyInfo) {
              setSurveyInfo(JSON.parse(res.data.surveyInfo));
              console.log('勘测信息', JSON.parse(res.data.surveyInfo));
            }
            if (res.data.installationInfo) {
              setInstallation(JSON.parse(res.data.installationInfo));
              console.log('安装信息', JSON.parse(res.data.installationInfo));
            }
            if (res.data.questionnaireInfo) {
              setQuestionInfo(JSON.parse(res.data.questionnaireInfo));
              console.log('问卷内容', JSON.parse(res.data.questionnaireInfo));
              let newArr = evaluateGrade;

              for (
                let i = 0;
                i < JSON.parse(res.data.questionnaireInfo).mark;
                i++
              ) {
                newArr[i] = yellowStar;
                console.log(newArr[i]);
              }
              console.log(newArr);
              setEvaluateGrade([...newArr]);
            }
            FullLoading.hide();
          })
          .catch(error => {
            setEmptyShow(true);
            FullLoading.hide();
          });
      })
      .catch(err => {
        FullLoading.hide();
        console.error('err', err);
      });

    querySharePileInfo().then(pileShareRes => {
      console.log(pileShareRes, 'pileShareRes')
      if ([0, 200].includes(pileShareRes.code)) {
        setPileShareInfo(pileShareRes?.data || {})
      }
    })
  }, []);

  useEffect(() => {
    console.log(isInView, 'isInView')
    if (isInView) {
      const openSimpleShareModal = localStorage.getItem('openSimpleShareModalAfterConfirm')
      console.log(openSimpleShareModal, 'openSimpleShareModal')
      if (openSimpleShareModal === '1') {
        setVisible(true)
        localStorage.removeItem('openSimpleShareModalAfterConfirm')
      }
    }
  }, [isInView])

  return (
    <div className="survey" ref={suery}>
      {
        isXPApp ? (
          <div className="nav-bar">
            <div className="nav-bar-left" onClick={goBack}></div>
            <span className='title'>报装家充桩</span>
          </div>
        ) : null
      }
      {
        showCoupons.show && <div className={couponsClass} onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
          <img className='coupons-icon' src={showCoupons.info} alt="暂无图片" />
        </div>
      }
      {!emptyShow && (
        <div className="content">
          <div className="schedule">
            <div className="steps">
              <img src={'https://s.xiaopeng.com/xp-charge/charge/pile-apply/check-radio-black.png'} alt="" className="steps-icon"></img>
              <p className="liner2"></p>
              <img
                src={
                  orderInfo &&
                    orderInfo.surveyInfo &&
                    orderInfo.orderStatus !== '12'
                    ? 'https://s.xiaopeng.com/xp-charge/charge/pile-apply/check-radio-black.png'
                    : 'https://s.xiaopeng.com/xp-charge/charge/pile-apply/check-radio.svg'
                }
                alt=""
                className="steps-icon"
              ></img>
              <p className="liner2"></p>
              <img
                src={
                  orderInfo &&
                    orderInfo.installationInfo &&
                    orderInfo.orderStatus !== '18'
                    ? 'https://s.xiaopeng.com/xp-charge/charge/pile-apply/check-radio-black.png'
                    : 'https://s.xiaopeng.com/xp-charge/charge/pile-apply/check-radio.svg'
                }
                alt=""
                className="steps-icon"
              ></img>
            </div>
            <div className="steps-title">
              <div className="text">申请报装</div>
              <div className="text">现场勘测</div>
              <div className="text">上门安装</div>
            </div>
          </div>
          <div className="speed-content">
            <div className="fill">

              {orderInfo && showEvaluateBtn(orderInfo) ? (
                getTypeData(pileShareInfo)?.type !== 'opened'
                  ?
                  <>
                    <SharePileModal newPileShareInfo={pileShareInfo} onChange={() => { }} open={visible} type='pile-installation' orderNo={orderNo} />
                    <div className="comes-install">
                      <img src={bigCircular} alt="" className="bigCircular" />
                      <div className="install-box">
                        <div className="title">
                          <div className="title-text">请评价本次服务</div>
                          <button onClick={gotoEvaluation}>去评价</button>
                        </div>
                      </div>
                    </div>
                  </>
                  :
                  <>
                    <div className="comes-install">
                      <img src={bigCircular} alt="" className="bigCircular" />
                      <div className="install-box">
                        <div className="title">
                          <div className="title-text">请评价本次服务</div>
                          <button onClick={gotoEvaluation}>去评价</button>
                        </div>
                      </div>
                    </div>
                    <SharePileModal newPileShareInfo={pileShareInfo} onChange={() => { }} open={visible} type='pile-installation' orderNo={orderNo} />
                  </>
              ) : (
                ''
              )}

              {orderInfo && orderInfo.questionnaireInfo ? (
                <>
                  <SharePileModal newPileShareInfo={pileShareInfo} onChange={() => { }} open={visible} type='pile-installation' orderNo={orderNo} />
                  <div className="evaluate">
                    <img src={bigCircular} alt="" className="bigCircular" />
                    <div className="evaluate-info">
                      <div className="info-title">
                        我的评价：
                        {evaluateGrade &&
                          evaluateGrade.map((item, index) => (
                            <img src={item} alt="" key={index} />
                          ))}
                      </div>
                      {questionInfo && <div className="info-text">
                        {questionInfoList.map((item, index) => {
                          return (
                            <div key={index}>
                              {questionInfo[item.value] === 1 ? item.name : ''}
                            </div>
                          );
                        })}
                      </div>}
                      <div className="info-content">
                        {questionInfo && questionInfo.info}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ''
              )}

              {orderInfo &&
                orderInfo.orderStatus !== '18' &&
                orderInfo.installationInfo &&
                orderInfo.orderStatus !== '30' ? (
                <div className="installation">
                  <img src={smallCircular} alt="" className="smallCircular" />
                  <div className="info">
                    <img src={completed} alt="" className="completed" />
                    <div className="info-title">
                      <div>已确认安装报告</div>
                      <button onClick={() => gotoInstallReport()}>
                        安装报告
                      </button>
                    </div>
                    <div className="info-text">
                      安装时间：
                      {orderInfo &&
                        formateDatePile(orderInfo.installationFinishDate)}
                    </div>
                    <div className="info-text">
                      预计费用：{installationInfo && installFee()}元
                    </div>
                    <div></div>
                  </div>
                </div>
              ) : (
                ''
              )}
              {orderInfo && orderInfo.orderStatus === '18' ? (
                <div className="property">
                  <img src={bigCircular} alt="" className="bigCircular" />
                  <div className="confirm-res">
                    <div className="title">请确认安装结果</div>
                    <div className="surveyDate">
                      安装时间：
                      {orderInfo &&
                        formateDatePile(orderInfo.installationFinishDate)}
                    </div>
                    <div className="survey-fee">
                      安装费用：
                      <span>{installationInfo && installFee()}元</span>
                    </div>
                    <div className="btn">
                      <div></div>
                      <button onClick={() => gotoInstallReport()}>
                        去确认
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
              {orderInfo &&
                orderInfo.installationInfo &&
                orderInfo.orderStatus !== '30' ? (
                <div className="site-survey">
                  <div>
                    <p>上门安装</p>
                  </div>
                  <img src={bigCircular} alt="" className="bigCircular" />
                </div>
              ) : (
                ''
              )}
              {orderInfo &&
                ['03', '06', '09'].includes(orderInfo.orderStatus) ? (
                <div className="comes-install">
                  <img src={bigCircular} alt="" className="bigCircular" />
                  <div className="install-box">
                    <div className="title">
                      <div className="title-text">等待师傅上门勘测</div>
                      {orderInfo && orderInfo.urgeCount >= 1 ? (
                        <div className="urged">今日已催办</div>
                      ) : (
                        <div className="urge" onClick={urge}>
                          催办
                        </div>
                      )}
                    </div>
                    <div className="surveyDate">
                      <span>家充管家24小时内联系沟通上门时间</span>
                      <br />
                      <span>具备安装条件后,由服务人员带桩上门安装</span>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
              {orderInfo && ['15'].includes(orderInfo.orderStatus) ? (
                <div className="comes-install">
                  <img src={bigCircular} alt="" className="bigCircular" />
                  <div className="install-box">
                    <div className="title">
                      <div className="title-text">等待师傅上门安装</div>
                      {orderInfo && orderInfo.urgeCount >= 1 ? (
                        <div className="urged">今日已催办</div>
                      ) : (
                        <div className="urge" onClick={urge}>
                          催办
                        </div>
                      )}
                    </div>
                    <div className="surveyDate">具备安装条件后,由服务人员带桩上门安装</div>
                  </div>
                </div>
              ) : (
                ''
              )}
              {orderInfo &&
                orderInfo.orderStatus !== '12' &&
                orderInfo.surveyInfo &&
                orderInfo.orderStatus !== '30' ? (
                <div className="installation">
                  <img src={smallCircular} alt="" className="smallCircular" />
                  <div className="info">
                    <img src={completed} alt="" className="completed" />
                    <div className="info-title">
                      <div>已确认勘测结果</div>
                      <button onClick={() => gotoSurveyReport()}>
                        勘测报告
                      </button>
                    </div>
                    <div className="info-text">
                      勘测时间：
                      {orderInfo && formateDatePile(orderInfo.surveyFinishDate)}
                    </div>
                    <div className="info-text">
                      预计费用：{surveyInfo && surveyFee()}元
                    </div>
                    <div></div>
                  </div>
                </div>
              ) : (
                ''
              )}
              {orderInfo &&
                orderInfo.orderStatus !== '12' &&
                orderInfo.surveyInfo &&
                orderInfo.orderStatus !== '30' ? (
                <div className="site-survey">
                  <div>
                    <p>现场勘测</p>
                  </div>
                  <img src={bigCircular} alt="" className="bigCircular" />
                </div>
              ) : (
                ''
              )}
              {orderInfo && orderInfo.orderStatus === '12' ? (
                <div className="property">
                  <img src={bigCircular} alt="" className="bigCircular" />
                  <div className="confirm-res">
                    <div className="title">确认勘测结果</div>
                    <div className="surveyDate">
                      勘测时间：
                      {orderInfo && formateDatePile(orderInfo.surveyFinishDate)}
                    </div>
                    <div className="survey-fee">
                      预计费用：<span>{surveyInfo && surveyFee()}元</span>
                    </div>
                    <div className="btn">
                      <div></div>
                      <button onClick={gotoSurveyReport}>去确认</button>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
              {orderInfo && shwoConfirmWithManagement()}
              {orderInfo && communicationGuide()}
              {orderInfo && orderInfo.orderStatus === '30' ? (
                <div className="site-survey">
                  <div>
                    <p>中途结束</p>
                  </div>
                  <img src={redCirdular} alt="" className="bigCircular" />
                </div>
              ) : (
                ''
              )}
              <div className="installation">
                <img src={smallCircular} alt="" className="smallCircular" />
                <div className="info">
                  <div className="info-title">已提交申请表</div>
                  {orderInfo && orderInfo.applyInstallationDate !== 0 ? (
                    <div className="info-text">
                      申请时间：
                      {orderInfo &&
                        formateDatePile(orderInfo.applyInstallationDate)}
                    </div>
                  ) : (
                    ''
                  )}
                  <div className="info-text">
                    联系人：{orderInfo && orderInfo.contactName}{' '}
                    {orderInfo && orderInfo.contactPhone}
                  </div>
                  <div></div>
                </div>
              </div>
              <div className="title">
                <p>申请报装</p>
                <img src={bigCircular} alt="" className="bigCircular" />
              </div>
            </div>
          </div>
        </div>
      )}
      {!emptyShow && (
        <div className="contact">
          {orderInfo && orderInfo.serviceProviderManagerPhone ? (
            <a
              href={`tel:${orderInfo && orderInfo.serviceProviderManagerPhone}`}
            >
              联系家充管家
            </a>
          ) : (
            <div className="text">正在为您分配家充管家</div>
          )}
        </div>
      )}

      <DatePicker
        title={'选择时间'}
        show={show}
        date={date}
        onCancel={() => setShow(false)}
        selectedIndexs={[0]}
        onSure={onSure}
      />
      {emptyShow && (
        <div className="empty">
          <img src={emptyStatus} alt="" />
          <div className="title">暂无内容</div>
        </div>
      )}
    </div>
  );
};
export default Survey;
